module.exports = __webpack_public_path__ + "static/media/karnebalen.4f289cf8.png";